import { render, staticRenderFns } from "./EstimatesJournal.vue?vue&type=template&id=c0aa8f72&"
import script from "./EstimatesJournal.vue?vue&type=script&lang=ts&"
export * from "./EstimatesJournal.vue?vue&type=script&lang=ts&"
import style0 from "./EstimatesJournal.vue?vue&type=style&index=0&id=c0aa8f72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports